import { Component, EventEmitter, inject, OnInit, Output } from "@angular/core";
import { CommonModule, AsyncPipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import {
  Router,
  NavigationEnd,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import { SvgIconComponent } from "angular-svg-icon";
import { DropDown } from "../drop-down/drop-down";
import { filter } from "rxjs/operators";
import { FirebaseAuthService } from "../../services/firebase-auth.service";
import { Settings } from "../../utils/settings";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { AnimationItem } from "lottie-web";
import { Observable } from "rxjs";
import { User } from "@angular/fire/auth";

@Component({
  selector: "app-nav-top-public",
  standalone: true,
  imports: [
    CommonModule,
    AsyncPipe,
    FormsModule,
    SvgIconComponent,
    DropDown,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: "./nav-top-public.html",
  styleUrls: ["./nav-top-public.scss"],
})
export class NavTopPublic implements OnInit {
  private router = inject(Router);
  private firebaseAuth = inject(FirebaseAuthService);

  theme = "";
  isLoginRoute = false;
  isLoggedIn = false;
  user$: Observable<User | null>;
  @Output() toggleDrawer = new EventEmitter<unknown>();

  options_light: AnimationOptions = {
    // path: '/assets/icons/lottie/voice-on-white1.json',
    path: "/assets/icons/lottie/wave-lines-white.json",
  };

  options_dark: AnimationOptions = {
    // path: '/assets/icons/lottie/voice-on-black.json',
    path: "/assets/icons/lottie/wave-lines-black.json",
  };

  constructor() {
    this.user$ = this.firebaseAuth.user$;
  }

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

  async ngOnInit() {
    // Listen to route changes to update isLoginRoute
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isLoginRoute = event.url === "/login";
      });

    // Set initial state based on current URL
    this.isLoginRoute = this.router.url === "/login";
    console.log("this.isLoginRoute: ", this.isLoginRoute);

    // Subscribe to auth state
    this.firebaseAuth.user$.subscribe((user) => {
      this.isLoggedIn = !!user;
    });

    // Load theme from Settings on init
    const savedTheme = await Settings.get<string>("theme");

    console.log("Saved theme from Settings:", savedTheme);

    // Use setTimeout to ensure the select element is fully initialized
    setTimeout(() => {
      if (savedTheme) {
        // Only set the theme if it's 'light' or 'dark' (valid options in the select)
        if (savedTheme === "light" || savedTheme === "dark") {
          this.theme = savedTheme;
        } else {
          // If it's another theme (like 'cupcake'), default to empty
          this.theme = "";
        }
        document.documentElement.setAttribute("data-theme", savedTheme);
      } else {
        // No saved theme, set empty string to show placeholder
        this.theme = "";
      }

      console.log("Theme set to:", this.theme);
    }, 0);
  }

  async changeTheme(event: Event): Promise<void> {
    const selectElement = event.target as HTMLSelectElement;
    const selectedTheme = selectElement.value;
    this.theme = document.documentElement.getAttribute("data-theme")!;
    if (this.theme === "light") {
      document.documentElement.setAttribute("data-theme", "dark");
      this.theme = "dark";
      await Settings.set("theme", "dark");
    } else {
      document.documentElement.setAttribute("data-theme", "light");
      this.theme = "light";
      await Settings.set("theme", "light");
    }
  }

  async onThemeSelectChange(event: Event): Promise<void> {
    const selectElement = event.target as HTMLSelectElement;
    const selectedTheme = selectElement.value;
    this.theme = selectedTheme;
    document.documentElement.setAttribute("data-theme", selectedTheme);
    await Settings.set("theme", selectedTheme);
  }

  async onLogout(): Promise<void> {
    this.firebaseAuth.signOut().then(async () => {
      await Settings.remove("isAuthenticated");
      await Settings.remove("rememberedEmail");
      this.router.navigate(["/logout"]);
    });
  }
}
